/* Joins the Liquid-emitted live catalog (window.PLANNER_LIVE — variant IDs,
   SKUs, prices, option values; see SHOPIFY_DATA_CONTRACT.md) onto the generated
   snapshot (window.PLANNER_DATA) before the planner boots. The snapshot keeps
   the curated geometry/classification; live data supplies commercial truth.
   Records with no live counterpart are dropped so the planner never offers an
   unpublished product. Without PLANNER_LIVE (the local prototype) this is a
   no-op and snapshot prices are used as-is. */
(function(){
  const live = window.PLANNER_LIVE, D = window.PLANNER_DATA;
  if(!live || !D || live.schemaVersion !== 2) return;

  const bySku = new Map(), byOpts = new Map();
  for(const [handle, product] of Object.entries(live.products)){
    for(const v of product.variants){
      if(!v.image && product.image) v.image = product.image;
      if(v.sku && !bySku.has(v.sku)) bySku.set(v.sku, v);
      byOpts.set(handle + '::' + v.options.map(o => o.value).join('|'), v);
    }
  }

  const stats = {matched: 0, dropped: []};
  const ids = {};
  const adopt = (rec, v) => {
    if(v.sku) rec.sku = v.sku;      // live SKU wins over a stale snapshot SKU
    rec.price = v.priceCents;
    rec.variantId = v.id;
    if(v.image) rec.image = v.image;   // colour-accurate variant image for quick view
    ids[rec.sku] = v.id;
    stats.matched++;
  };

  D.panels = D.panels.filter(p => {
    let v = bySku.get(p.sku);
    if(!v){
      // SKU drift fallback (e.g. "SS-P-3216 DS-1" -> "SS-P-3216 DS"): a panel
      // record is unique per handle+colour, so an unambiguous colour match wins
      const cand = ((live.products[p.handle] || {}).variants || [])
        .filter(x => x.options.some(o => o.value === p.color));
      if(cand.length === 1) v = cand[0];
    }
    if(!v){ stats.dropped.push(p.sku); return false; }
    adopt(p, v);
    return true;
  });

  D.kits = D.kits.filter(kit => {
    kit.variants = (kit.variants || []).filter(kv => {
      // join by option values first: SKUs have drifted on at least one kit
      // variant since the CSV snapshot, option values have not
      const vals = [kv.option1, kv.option2]
        .filter(o => o && o.value).map(o => o.value);
      const v = byOpts.get(kit.handle + '::' + vals.join('|')) || bySku.get(kv.sku);
      if(!v){ stats.dropped.push(kv.sku); return false; }
      adopt(kv, v);
      return true;
    });
    return kit.variants.length > 0;
  });

  if(D.vbracket){
    for(const h of Object.keys(D.vbracket.heights)){
      const colors = D.vbracket.heights[h];
      for(const c of Object.keys(colors)){
        const v = bySku.get(colors[c].sku);
        if(!v){ stats.dropped.push(colors[c].sku); delete colors[c]; continue; }
        adopt(colors[c], v);
      }
      if(!Object.keys(colors).length) delete D.vbracket.heights[h];
    }
    if(!Object.keys(D.vbracket.heights).length) D.vbracket = null;
  }

  window.PLANNER_VARIANT_IDS = ids;      // sku -> variant id, for the cart payload
  window.PLANNER_LIVE_MERGE = stats;     // debugging: match/drop tally
})();
